import { alpha, styled } from "@mui/material/styles";
import React from "react";

import { ID } from "@holibob-packages/id";

import { MainColumnVariableMargin } from "../../../components/MainColumnWrapper";
import { ProductReviewFragment, ProductReviewSummaryFragment } from "../../../gql-request";
import { ProductReview } from "../ProductReview";
import { ProductSectionWrapper, ProductSectionWrapperProps } from "./ProductSectionWrapper";

export type ProductReviewSectionProps = Omit<ProductSectionWrapperProps, "children"> & {
    productId: ID;
    initialData: {
        reviewList: ProductReviewFragment[];
        reviewSummary: ProductReviewSummaryFragment;
        pageCount: number;
    };
    className?: string;
    boundaryCount?: number;
    onPageChange?: (page?: number) => void;
};

export function ProductReviewSection(props: ProductReviewSectionProps) {
    return (
        <ProductSectionWrapper
            ContainerComponent={ProductReviewSectionWrapper}
            {...props}
            id="product-review-section"
            data-testid="product-review-section"
        >
            <ProductReview {...props} />
        </ProductSectionWrapper>
    );
}

const ProductReviewSectionWrapper = styled("div")(({ theme }) => ({
    backgroundColor: alpha(theme.palette.primary.main, 0.15),
    marginLeft: `calc(${MainColumnVariableMargin.reference} * -1)`,
    marginRight: `calc(${MainColumnVariableMargin.reference} * -1)`,
    paddingLeft: MainColumnVariableMargin.reference,
    paddingRight: MainColumnVariableMargin.reference,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        marginLeft: 0,
        paddingLeft: theme.spacing(4),
    },
}));
